"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _DocumentSelectorPanel = _interopRequireDefault(require("./DocumentSelectorPanel"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["classes", "documents", "currentDocumentId", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      height: '100%',
      width: '100%',
      background: 'white'
    },
    menu: {
      padding: 0,
      overflowY: 'auto',
      height: '100%'
    }
  };
};

var DocumentSelector = function DocumentSelector(props) {
  var classes = props.classes,
      documents = props.documents,
      currentDocumentId = props.currentDocumentId,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var menuItems = documents.map(function (doc) {
    var id = doc.id;
    var isExpanded = id === currentDocumentId;
    return /*#__PURE__*/_react.default.createElement(_DocumentSelectorPanel.default, _extends({
      key: id,
      doc: doc,
      isExpanded: isExpanded
    }, rest));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.List, {
    component: "nav",
    className: classes.menu
  }, menuItems));
};

var _default = (0, _styles.withStyles)(styles)(DocumentSelector);

exports.default = _default;